import { get } from "svelte/store"
import { doAction, logText } from "./game";
import { res } from "./stores";

export function collectiveValues(){
    let ret = borgTracks();
    if(ret) return ret.values;
    return {
        16: 1,
        22: 2,
        28: 3,
        34: 4
    }
}

export function borgPassives(){
    let custom = get(res).customDashboards && get(res).customDashboards['Borg Queen'];
    if(custom && custom.passives) return custom.passives;

    let lines = [
        `Passive: When you would log a [[location]] or complete a [[mission]] card, assimilate it instead. When you would log any other card, instead either: expend a [[drone]] to assimilate it OR destroy it. This satisfies the cost of logging, but does not trigger logging reactions.`,
        `Passive: You cannot deploy [[ship]] that does not have [[borg]]. Your [[ship]] can only be warped by effects on cards with [[borg]].`,
        `Passive: You meet [[res-restriction]]/[[inf-restriction]]/[[mil-restriction]] requirements by having ^twice^ as large [[collective]] value.`,
        `Passive: Your [[collective]] multiplier acts as a multiplier for [[res-focus]]/[[inf-focus]]/[[mil-focus]].`,
        `Endgame: You ^do not score^ for tokens in the Neutral Zone.`
    ];

    return lines.map((l, i) => {
        return {
          name:`Borg Queen dashboard passives #${i + 1}`,
          allText: l,
          text: l,
          id: `borg_passives_${i+1}`,
          //uniqueID: getUniqueID(),//`borg_passives`,
          suits: [],
          traits: [],
          values: [],
          ships: [],
          dashboardPassive: true,
          deck: 'Borg Queen'
        }
    })
}

export function borgTracks(){
    if(!get(res).customDashboards || !get(res).customDashboards['Borg Queen'] || !get(res).customDashboards['Borg Queen'].tracks) return false;
    let tracks = get(res).customDashboards['Borg Queen'].tracks;
    let rewards = {};
    let values = {};
    for(let k of Object.keys(tracks)){
        if(typeof tracks[k] == 'number'){
            values[k] = tracks[k];
        }else{
            rewards[k] = tracks[k];
        }
    }
    return {values, rewards};
}

export function collectiveRewards(){
    let ret = borgTracks();
    if(ret) return ret.rewards;
    return {
        7: 'drone',
        20: 'drone',
        31: 'glory',
        37: 'action'
    }
}

export function collectiveTrackList(){
    return {...collectiveValues(), ...collectiveRewards()};
}

export async function checkCollectiveRewards(p, before, after){
    if(p.bot){
        console.log('BQ bot does not get collective rewards');
        return;
    }
    for(let k of Object.keys(collectiveRewards())){
        if(before < parseInt(k) && after >= parseInt(k)){
            // take reward
            let reward = collectiveRewards()[k];
            logText(`Reward triggered for passing [[collective]] threshold: player gains a [[${reward}]]`);
            if(reward == 'drone'){
                // add drone
                await doAction(p, 'extra_drones', {num: 1});
            }else if(reward == 'glory'){
                await doAction(p, 'gain_tokens', {token: 'glory', amount: 1});
            }else if(reward == 'action'){
                await doAction(p, 'gain_tokens', {token: 'actions', amount: 1});
            }
        }
    }
}
